import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "../features/player/playerSlice";
import organizerReducer from "../features/organizer/organizerSlice";
import organizerCreateTournamentReducer from "../features/organizer/organizerCreateTournamentSlice";
import organizerStatsReducer from "../features/organizer/organizerStatsSlice";
import organizerPlayersReducer from "../features/organizer/organizerPlayersSlice";
import globalReducer from "../features/global/globalSlice";
import chartDataReducer from "../features/player/chartDataSlice";
import modalReducer from "../features/modals/modalSlice";
import refreshReducer from "../features/refreshScreen/refreshScreenSlice";
import { playerApi } from "../services/playerApi";
import { organizerApi } from "../services/organizerApi";
import { avatarApi } from "../services/avatarApi";
import { emailApi } from "../services/emailApi";
import { findTournamentApi } from "../services/findTournamentApi";
import { registerApi } from "../services/registerApi";
import { paypalApi } from "../services/paypalApi";
import { clubPageApi } from "../services/clubPageApi";
import preRegistrationReducer from "../features/player/preRegistrationSlice";
import { dashboardApi } from "../services/dashboardApi";
import { seasonsApi } from "../services/seasonsApi";
import { stripeApi } from "../services/stripeApi";
import { notificationsApi } from "../services/notificationsApi";
import { groupsApi } from "../services/groupsApi";
import { sharedCourtsApi } from "../services/sharedCourtsApi";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    player: profileReducer,
    preRegistration: preRegistrationReducer,
    organizer: organizerReducer,
    organizerPlayers: organizerPlayersReducer,
    organizerStats: organizerStatsReducer,
    tournamentForm: organizerCreateTournamentReducer,
    chartData: chartDataReducer,
    modal: modalReducer,
    refresh: refreshReducer,
    [playerApi.reducerPath]: playerApi.reducer,
    [stripeApi.reducerPath]: stripeApi.reducer,
    [seasonsApi.reducerPath]: seasonsApi.reducer,
    [registerApi.reducerPath]: registerApi.reducer,
    [paypalApi.reducerPath]: paypalApi.reducer,
    [findTournamentApi.reducerPath]: findTournamentApi.reducer,
    [clubPageApi.reducerPath]: clubPageApi.reducer,
    [emailApi.reducerPath]: emailApi.reducer,
    [organizerApi.reducerPath]: organizerApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [avatarApi.reducerPath]: avatarApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [groupsApi.reducerPath]: groupsApi.reducer,
    [sharedCourtsApi.reducerPath]: sharedCourtsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(playerApi.middleware)
      .concat(seasonsApi.middleware)
      .concat(registerApi.middleware)
      .concat(paypalApi.middleware)
      .concat(findTournamentApi.middleware)
      .concat(clubPageApi.middleware)
      .concat(emailApi.middleware)
      .concat(avatarApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(organizerApi.middleware)
      .concat(stripeApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(groupsApi.middleware)
      .concat(sharedCourtsApi.middleware),
});
